var _style, _defs, _defs2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRaceAndCultureFinal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000084513903245381008370000010211555199373880990_);}\n\t\n\t\t.st1{clip-path:url(#SVGID_00000084513903245381008370000010211555199373880990_);fill-rule:evenodd;clip-rule:evenodd;fill:#563213;}\n\t\n\t\t.st2{clip-path:url(#SVGID_00000084513903245381008370000010211555199373880990_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000109026081027275180760000000566334275734725279_);}\n\t\n\t\t.st3{clip-path:url(#SVGID_00000084513903245381008370000010211555199373880990_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000041256981991138411770000004527357738124578239_);}\n\t\n\t\t.st4{clip-path:url(#SVGID_00000084513903245381008370000010211555199373880990_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000180359848225179913360000000575710423278601907_);}\n\t\n\t\t.st5{clip-path:url(#SVGID_00000084513903245381008370000010211555199373880990_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000068637464885242152640000006065021496471722663_);}\n\t\n\t\t.st6{clip-path:url(#SVGID_00000084513903245381008370000010211555199373880990_);fill-rule:evenodd;clip-rule:evenodd;fill:#008FA3;}\n\t\n\t\t.st7{clip-path:url(#SVGID_00000084513903245381008370000010211555199373880990_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000126319247319930811360000008776829729848145593_);}\n\t\n\t\t.st8{clip-path:url(#SVGID_00000084513903245381008370000010211555199373880990_);fill-rule:evenodd;clip-rule:evenodd;fill:#0097AF;}\n\t\n\t\t.st9{clip-path:url(#SVGID_00000084513903245381008370000010211555199373880990_);fill-rule:evenodd;clip-rule:evenodd;fill:#926C3C;}\n\t\n\t\t.st10{clip-path:url(#SVGID_00000084513903245381008370000010211555199373880990_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000106847541520386779210000016798112046089447861_);}\n\t\n\t\t.st11{clip-path:url(#SVGID_00000084513903245381008370000010211555199373880990_);fill-rule:evenodd;clip-rule:evenodd;fill:#1B1464;}\n\t\n\t\t.st12{clip-path:url(#SVGID_00000084513903245381008370000010211555199373880990_);fill-rule:evenodd;clip-rule:evenodd;fill:#4C3710;}\n\t\n\t\t.st13{clip-path:url(#SVGID_00000084513903245381008370000010211555199373880990_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000132775040144036187700000007145951042486635684_);}\n\t\n\t\t.st14{clip-path:url(#SVGID_00000084513903245381008370000010211555199373880990_);fill-rule:evenodd;clip-rule:evenodd;fill:#2E3192;}\n\t\n\t\t.st15{clip-path:url(#SVGID_00000084513903245381008370000010211555199373880990_);fill-rule:evenodd;clip-rule:evenodd;fill:#754C24;}\n\t\n\t\t.st16{clip-path:url(#SVGID_00000084513903245381008370000010211555199373880990_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000158737600236226057390000010677124430271971988_);}\n\t.st17{clip-path:url(#SVGID_00000084513903245381008370000010211555199373880990_);fill-rule:evenodd;clip-rule:evenodd;}\n\t\n\t\t.st18{clip-path:url(#SVGID_00000084513903245381008370000010211555199373880990_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000008840451007200288920000003867171375602733748_);}\n\t\n\t\t.st19{clip-path:url(#SVGID_00000084513903245381008370000010211555199373880990_);fill-rule:evenodd;clip-rule:evenodd;fill:#FF931E;}\n\t\n\t\t.st20{clip-path:url(#SVGID_00000084513903245381008370000010211555199373880990_);fill-rule:evenodd;clip-rule:evenodd;fill:#8C6239;}\n\t\n\t\t.st21{clip-path:url(#SVGID_00000084513903245381008370000010211555199373880990_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000094595179534428965190000003544090320169304208_);}\n\t\n\t\t.st22{clip-path:url(#SVGID_00000084513903245381008370000010211555199373880990_);fill-rule:evenodd;clip-rule:evenodd;fill:#FF7BAC;}\n\t\n\t\t.st23{clip-path:url(#SVGID_00000084513903245381008370000010211555199373880990_);fill-rule:evenodd;clip-rule:evenodd;fill:#4A2E2E;}\n\t\n\t\t.st24{clip-path:url(#SVGID_00000084513903245381008370000010211555199373880990_);fill-rule:evenodd;clip-rule:evenodd;fill:#6B4926;}\n\t\n\t\t.st25{clip-path:url(#SVGID_00000084513903245381008370000010211555199373880990_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000004544219120054291310000012375445745815143822_);}\n\t\n\t\t.st26{clip-path:url(#SVGID_00000084513903245381008370000010211555199373880990_);fill-rule:evenodd;clip-rule:evenodd;fill:#9900CC;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M429.3,74C254.1,97.1,38.9,191.9,16.4,379.3c0,0-20,142.3,10.3,282.5C44.8,745,98.4,818,175.4,864.2 c77,46.2,171,61.6,260.5,42.9c58.2-12.2,118.4-20.4,178.1-18.1c104,3.9,201.1,1.7,263.2-85.6c55.4-77.9,104.3-176,112.8-269.5 c5.8-63.6-3.6-134.9-22.7-196.1C869.7,25.4,604.5,50.8,429.3,74z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000036940519728302883520000011685680220887484314_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000036940519728302883520000011685680220887484314_)"
    }
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000135657691731475771280000001035770710000497593_",
    d: "M426.1,52.2C236.4,77.3,3.4,180-21,382.9 c0,0-21.7,154,11.2,305.9c19.5,90.1,77.5,169.2,161,219.2c83.4,50,185.2,66.7,282.1,46.4c63-13.2,128.2-22.1,192.9-19.6 c112.7,4.2,217.8,1.8,285-92.7c60-84.4,112.9-190.6,122.2-291.9c6.3-68.8-3.9-146-24.6-212.4C903-0.4,615.8,27.2,426.1,52.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000144320899014333619240000003767184481258736028_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000135657691731475771280000001035770710000497593_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -1.907349e-06 0)",
    style: {
      clipPath: "url(#SVGID_00000144320899014333619240000003767184481258736028_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 800,
    height: 800,
    xlinkHref: "../../../../../\\u2014Pngtree\\u2014modern colorful watercolor background_3541854.jpg",
    transform: "matrix(1.3371 0 0 1.3371 -29.7196 -26.9692)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000036940519728302883520000011685680220887484314_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#563213"
    },
    d: " M199.9,868.5c2.8-23.2,29-226.8,29.7-236.5l1.1-10c1-27.7-2.1-54.2-15.4-75.5c-12.6-20.3-18.6-35.9-23.1-57.8 c-1.4-6.9-2.7-14.1-5.8-20.7c-0.9-2-1.8-4.1-2.9-6c-0.4-0.9-1.4-2.7-1.5-2.9c-1.7-3.2-5.2-7.6-4.7-11.1c0.5-3.3,4.6-4.3,8.6-4.3 c8-0.2,14.4,7.4,15.5,8.7c0.9,1.2,4,5.5,5.6,8.3c5.1,8.8,7.4,18.1,10.7,27.2c0.2,0.6,0.4,1.2,0.7,1.9c0.4,1,1.8,3.5,3.8,4.9 c0.8,0.6,1.8,1,2.8,1c0.7,0,1.4-0.1,2.1-0.5c1.4-0.7,2.3-1.8,3-3c1-1.7,1.5-3.7,2.1-5.2c3.2-8.2,3.3-17,4.4-25.3 c2.1-16.3,12.6-86.9,14.2-94.6c1.1-5.3,4.7-27.2,6.5-31.6c1-2.5,1.2-5,3.5-7.1c1.2-1.1,1.9-1.9,3.6-2.6c2.5-1.1,5.1-1.5,7.8,0.2 c0.8,0.5,1.5,1,2.1,1.6c1.9,2,2.4,4.3,2.4,6.7c0,4-1.5,22.4-2.3,27.5c-0.9,5.5-4.7,59.4-5.2,64.2c-0.5,5.1-1.3,10.3-1.4,15.4 c0,0.6-0.3,2.5,0.2,3.7c0.3,0.6,0.8,0.9,1.5,0.9c1.1,0,1.7-0.5,2-1c0.6-1.3,1-2.3,1.1-3.6c0.5-5.5,11.5-108.8,12.8-113.3 c0.6-2,1.4-4.7,3.8-6c3.4-1.8,8.5-1.1,11,1.2c1.5,1.4,2,3.2,2.3,4.9c0.8,5,1,10.4,0.6,15.5c-0.3,4.2-3.8,72.8-4.3,78.8 c-0.4,4.5-2.2,20.1-1.8,23.4c0.1,0.5,0.1,1.3,0.3,2.1c0.2,0.5,0.5,1,1,1.2c0.3,0.2,1.4,0.3,2,0c0.4-0.2,0.8-0.7,1.1-1.4 c0.3-0.8,0.5-1.7,0.5-2.4c0.1-1.6,0.6-3.8,0.6-5c0.2-5.4,6.7-94.2,8.3-99.9c0.7-2.4,1.6-5.3,3.6-7.4c1.1-1.2,2.6-1.9,4.8-1.9 c2.6,0,4.9,0.8,6.2,2.1c1.5,1.5,2.4,2.5,3,4.5c0.4,1.5,0.7,3.1,0.9,5c0.1,1.1,0.1,2.2,0.1,3.3c0,1.3,0.1,2.5,0,3.8 c0,4-2.9,77.1-3.3,79.7c-0.1,1-1.6,21.6-1,24.1c0.1,0.4,0.3,1,0.6,1.4c0.3,0.3,0.7,0.6,1.2,0.7c0.5,0.1,1.1-0.1,1.5-0.4 c0.6-0.4,1.1-1.1,1.2-1.6c0.7-2.8,1.4-6.3,1.6-9.1c0.5-6.8,2.6-77.9,6-83c1-1.5,1.6-3.2,3.4-4.5c0.6-0.5,3-1,3.9-1 c3.6,0,5.3,2.3,5.8,3.5c0.7,1.7,1.5,3.5,1.8,5.3c0.4,2.2,0.8,4.3,1.2,6.5c0.9,5,0.4,43.4,0.4,48.5c0,4-1.8,46.8-2.5,56.8 c-0.6,8.5-1.5,16.9-1.8,25.4c-0.3,8.3-0.1,16.6-0.9,25c-0.6,7-4.8,30.5-5.4,34.6c-1.8,12.1-3.1,24.3-4.7,36.5 c-1.9,13.6-2.9,27.4-5.1,41c-2,12.9-5.3,25.7-7,38.6c-0.6,4.8-24.8,187.1-26.1,196.1L199.9,868.5L199.9,868.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000045594142781524593690000014681947584366765706_",
    gradientUnits: "userSpaceOnUse",
    x1: 331.9043,
    y1: 786.6104,
    x2: 67.9905,
    y2: 739.7471
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2292,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000036940519728302883520000011685680220887484314_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000045594142781524593690000014681947584366765706_)"
    },
    d: " M183.9,897.9c9.2-48.3,17.8-122.2,20.8-151.1c2.6-25.1,10.4-42.1,11.4-57.6c2.8-22.3,0.5-40.8,7.1-45.4c4.6-3.3,12.6,1.7,28.5,2.9 c10.5,0.8,22.8,2.7,35.7,3c8.8,0.2,21.4-0.3,31.4-0.7c9.1-0.3,16-0.7,17.7,2.1c1.7,2.6,0.9,6.8,0,12.9c-1.8,11.6-1.3,29.6-3.1,48.2 c-1.4,14.3-3.6,28.9-5.3,53.5c-3.3,45.4-21.2,148.1-21.2,148.1L183.9,897.9L183.9,897.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008854221133818023150000015049101570430024589_",
    gradientUnits: "userSpaceOnUse",
    x1: 226.8047,
    y1: 608.66,
    x2: 342.037,
    y2: 608.66
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2292,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000036940519728302883520000011685680220887484314_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000008854221133818023150000015049101570430024589_)"
    },
    d: " M227.8,598.5c-1.5,4.4-0.8,11.9-0.9,19.5c-0.1,7.5,113.9,9.5,114,2c0.1-7.5,1.1-14.5,1.1-20C342.2,591.2,227.9,589.6,227.8,598.5 L227.8,598.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176745072829969850690000004153668147806423999_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.4447,
    y1: 586.189,
    x2: 322.0339,
    y2: 568.5057
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2292,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000036940519728302883520000011685680220887484314_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000176745072829969850690000004153668147806423999_)"
    },
    d: " M282.6,580.8l7.4,0.2c0,0,0-1.7,0.1-3.4c0-0.9-0.3-1.8-1-2.5c-0.6-0.7-1.5-1.1-2.4-1.1c-0.1,0-0.3,0-0.4,0c-0.9,0-1.8,0.3-2.5,1 c-0.7,0.6-1.1,1.5-1.1,2.4C282.7,579,282.6,580.8,282.6,580.8L282.6,580.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109028458171270107610000007791806764515114394_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.3054,
    y1: 609.9999,
    x2: 313.6275,
    y2: 609.9999
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000036940519728302883520000011685680220887484314_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000109028458171270107610000007791806764515114394_)"
    },
    d: " M265.1,627.7c-10-11.8-8.8-29.3,2.7-39.1c11.5-9.8,29-8.1,39,3.7c10,11.8,8.8,29.3-2.7,39.1C292.6,641.2,275.2,639.5,265.1,627.7 L265.1,627.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000036940519728302883520000011685680220887484314_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#008FA3"
    },
    d: " M269.1,624.3c-8.1-9.5-7.1-23.7,2.1-31.6c9.3-7.9,23.4-6.6,31.5,3c8.1,9.5,7.1,23.7-2.1,31.6C291.4,635.2,277.2,633.8,269.1,624.3 L269.1,624.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011024139545665962980000005310065344192388273_",
    gradientUnits: "userSpaceOnUse",
    x1: 257.2168,
    y1: 617.9816,
    x2: 322.8412,
    y2: 589.2955
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2292,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000036940519728302883520000011685680220887484314_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000011024139545665962980000005310065344192388273_)"
    },
    d: " M285.4,608.9l4.1-11.4c0.3-0.8,1.1-1.2,1.9-0.9c0.8,0.3,1.2,1.1,0.9,1.9l-4.5,12.4c-0.2,0.6-0.8,1-1.4,1l-17.2-0.4 c-0.8,0-1.5-0.7-1.4-1.5c0-0.8,0.7-1.5,1.5-1.4L285.4,608.9L285.4,608.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000036940519728302883520000011685680220887484314_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#0097AF"
    },
    d: " M277.1,909.9c1.9-21.6,5.9-43.2,9.8-64.3c8.1-44.3,16.9-88.4,19.6-133.5c1.1-18.2,2.5-36.4,3.3-54.6c0.1-1.2-0.2-4.7-0.2-8.2 c0.8,0,1.5-0.1,2.2-0.1c0,3.6,0.3,7.2,0.2,8.4c-0.8,18.2-2.2,36.4-3.3,54.6c-2.7,45.1-11.6,89.3-19.7,133.8 c-3.8,21.1-7.9,42.7-9.8,64.3L277.1,909.9L277.1,909.9z M255.3,906.8c1.6-12.4,4.1-24.8,5.7-37.1c5.8-44.4,12.6-88.5,16.9-133 c2.4-24.8,5.4-49,9.2-73.6c0.7-4.4,1.1-8.8,1.5-13.2c0.7,0,1.5,0,2.3,0c-0.4,4.5-0.8,9.1-1.5,13.6c-3.9,24.6-6.8,48.7-9.2,73.5 c-4.4,44.6-11.1,88.7-16.9,133.1c-1.6,12.4-4.1,24.7-5.7,37.2L255.3,906.8L255.3,906.8z M235,903.9c9.5-85.4,18.4-171,30.1-256.1 l0.5,0.1c0.3,0,0.7,0.1,1,0.1l0.7,0.1c-11.6,85.1-20.6,170.7-30.1,256.1L235,903.9L235,903.9z M243.9,645.1 c-0.4,6.3-0.5,12.7-0.7,19c-0.7,20.3-4,40.4-6.9,60.4c-3.4,23.1-8.8,46.2-11.3,69.4c-3.8,36-4.3,70.3-16.5,104.8 c-0.2,0.6-0.8,0.9-1.4,0.7c-0.6-0.2-0.9-0.8-0.7-1.4c12.1-34.3,12.6-68.5,16.4-104.3c2.5-23.3,7.9-46.3,11.3-69.5 c3-20,6.2-40,6.9-60.2c0.2-6.5,0.4-12.9,0.7-19.4C242.4,644.8,243.1,644.9,243.9,645.1L243.9,645.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000036940519728302883520000011685680220887484314_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#926C3C"
    },
    d: " M833.8,804.3c1.6-25.8,0.4-113.2,0.6-124l0.6-11.1c-0.1-30.8-4.1-60.1-17.2-83.6c-12.4-22.2-18.6-39.5-23.7-63.7 c-1.6-7.6-3.1-15.6-6.2-22.9c-0.9-2.2-1.8-4.5-2.9-6.6c-0.4-1-1.4-3-1.5-3.2c-1.7-3.5-5.1-8.4-4.8-12.2c0.3-3.6,7.4-4.8,11.1-5 c7.3-0.4,13.6,7.9,14.7,9.3c0.9,1.4,3.9,6,5.5,9.1c5.1,9.6,7.6,20,11,30c0.2,0.7,0.5,1.4,0.7,2.1c0.4,1.1,3.2,8.2,7.5,2.4 c1.3-1.7,1.2-4.1,1.7-5.8c2.6-9.2,2.4-18.9,3.1-28.3c1.3-18.1,3.7-28,5.9-41.9c1.3-8.5,8.1-56.8,9.6-61.6c0.9-2.8,0.9-5.6,2.9-8 c1.1-1.3,1.7-2.1,3.2-3c2.3-1.3,4.6-1.7,7.3,0.1c0.7,0.5,1.3,1.2,2,1.7c3.3,2.4,2.9,16.2,2.4,20.7c-0.7,5.8-4.3,46.4-4.6,51.7 c-0.3,5.7-0.8,11.5-0.7,17.2c0,0.6-0.2,2.8,0.3,4.1c0.3,0.6,0.7,1,1.4,1c1,0,1.6-0.6,1.8-1.1c0.5-1.4,0.8-2.5,0.9-4 c0.3-6.2,1-12.1,1.6-18.7c0.5-5.5,3.5-61.8,7.1-70.5c0.9-2.1,1.1-5.2,3.3-6.7c3-2.1,7.8-1.4,10.2,1.1c1.5,1.5,2,3.5,2.3,5.4 c0.9,5.6,1.4,11.6,1.2,17.2c-0.1,4.7-1.1,27.8-1.2,30.8c-0.2,6.6-0.7,13.1-0.9,19.8c-0.2,5-1.2,22.4-0.7,26 c0.1,0.5,0.1,1.5,0.4,2.3c0.2,0.6,0.5,1.1,0.9,1.3c0.3,0.2,1.3,0.3,1.9,0c0.4-0.2,0.7-0.8,0.9-1.6c0.3-0.9,0.4-1.9,0.4-2.7 c0-1.8,0.4-4.2,0.4-5.6c-0.1-6,2.9-48.5,3.2-54.8c0.3-6.4,0.6-13,1.9-19.3c0.6-2.7,1.3-5.9,3-8.3c1-1.4,2.4-2.2,4.4-2.2 c2.4,0,4.5,0.7,5.8,2.1c1.5,1.6,2.4,2.7,3,5c0.5,1.7,0.7,3.5,1,5.6c0.1,1.2,0.2,2.5,0.2,3.6c0.1,1.4,0.2,2.8,0.2,4.2 c0.1,4.5-0.2,10.9-0.2,15.4c0.1,8.5-1.1,50.9-1.1,54.4c0,2.8-0.5,5.9,0.1,8.6c0.1,0.4,0.3,1.1,0.7,1.6c0.3,0.4,0.6,0.6,1.1,0.7 c0.5,0.1,1-0.1,1.4-0.5c0.6-0.5,1-1.2,1.1-1.8c0.5-3.2,1.1-7,1.1-10.1c0.2-7.6,2.4-38.3,2.6-40.6c0-0.1,0-0.1-0.1-0.2 c0.1-2.2,0.3-11.9,1.1-14.6c0.5-1.9,1.4-3.6,2.9-5c0.6-0.5,2.7-1.2,3.6-1.2c3.4-0.1,4.9,2.4,5.5,3.8c0.7,1.9,1.5,3.9,1.9,5.8 c0.4,2.5,0.9,4.7,1.4,7.2c1,5.5,0.8,11.2,0.9,16.8c0.1,4.4,0.2,52,0,63.1c-0.2,9.4-0.7,18.8-0.7,28.3c0,9.3,0.6,18.5,0.2,27.8 c-0.3,7.8-3.3,34-3.7,38.6c-1.1,13.5-1.9,27.1-2.9,40.7c-1.2,15.2-1.6,30.5-3.1,45.7c-1.4,14.4-3.9,28.7-4.9,43.1 c-0.4,5.4-7.8,136.6-0.7,82.2l-93.2-4L833.8,804.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036213845919500826600000008438999338385828768_",
    gradientUnits: "userSpaceOnUse",
    x1: 1103.9637,
    y1: 757.4151,
    x2: 589.702,
    y2: 775.9138
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2292,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000036940519728302883520000011685680220887484314_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000036213845919500826600000008438999338385828768_)"
    },
    d: " M788.9,884.1c15.4-43.6-5.6-58.4-4.4-81.5c1.6-30.2,19.9-36.4,16.9-48.6c-3.8-15.6-18.2-25.1-9.7-46.4 c4.3-10.7,21.8-17.7,35.8-15.6c0.8-16.2,0.1-24.9,0.2-35.7c0-1.8,0.9-3.5,2.4-4.7c1.5-1.2,3.6-1.9,5.7-1.9 c14.3,0.2,27.4-0.4,44.8-0.5c8.7,0,19.2-0.4,29-0.2c7.2,0.1,15.3,0.3,22,0.9c5.8,0.5,10.1,4.9,9.5,9.8c-1.6,13.5-1.2,23.7-0.6,33.9 c19.4-7,34.4,5.5,34.4,18.3c0,11.7-8.1,21.1-6.1,28.3c4.6,16.5,11.6,15.7,15.9,39.4c2.7,14.8-19.1,20.4-5.8,52.7 c10.4,25.1-6.6,35.6,1.5,47.2C980.6,879.3,791.9,880.6,788.9,884.1L788.9,884.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000036940519728302883520000011685680220887484314_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#1B1464"
    },
    d: " M839.3,649.7c-0.1,7.4-0.4,14-0.7,20.3c0,0.6-0.7,1.1-1.4,1.1c-0.7,0-1.3-0.6-1.3-1.2c0.3-6.2,0.6-12.8,0.7-20.2 C837.5,649.6,838.4,649.7,839.3,649.7L839.3,649.7z M849.9,649.6c-0.4,11.5-1.9,36.1-2.2,42.1c0,0.6-0.7,1.1-1.4,1.1 c-0.7,0-1.3-0.6-1.3-1.2c0.3-5.9,1.8-30.5,2.2-41.9C848,649.6,849,649.6,849.9,649.6L849.9,649.6z M862.8,649.4 c-0.3,9.6-1.6,27.1-1.9,33.1c0,0.6-0.7,1.1-1.4,1.1c-0.7,0-1.3-0.6-1.3-1.2c0.3-5.9,1.6-23.3,1.9-32.9l1.7,0L862.8,649.4 L862.8,649.4z M875.8,649.2c-0.1,7-0.4,13.3-0.7,19.2c0,0.6-0.7,1.1-1.4,1.1c-0.7,0-1.3-0.6-1.3-1.2c0.3-5.9,0.6-12.2,0.7-19.1 C874,649.2,874.9,649.2,875.8,649.2L875.8,649.2z M887.4,649.1c-0.3,16-1.7,28.4-0.9,41c0,0.6-0.5,1.2-1.3,1.2 c-0.7,0-1.4-0.5-1.4-1.1c-0.8-12.6,0.7-25.1,0.9-41.1C885.6,649.1,886.5,649.1,887.4,649.1L887.4,649.1z M899.3,648.9 c-0.2,16.2-1.7,28.7-0.9,41.4c0,0.6-0.5,1.2-1.3,1.2c-0.7,0-1.4-0.5-1.4-1.1c-0.8-12.7,0.7-25.3,0.9-41.5 C897.5,648.9,898.4,648.9,899.3,648.9L899.3,648.9z M911.6,649c-0.3,17.6-2,31.1-1.2,44.9c0,0.6-0.5,1.2-1.3,1.2 c-0.7,0-1.4-0.5-1.4-1.1c-0.8-13.8,0.9-27.4,1.2-45c0.3,0,0.6,0,0.8,0C910.3,649,910.9,649,911.6,649L911.6,649z M922.9,649.3 c-0.1,7.3-0.4,13.8-0.7,20c0,0.6-0.7,1.1-1.4,1.1c-0.7,0-1.3-0.6-1.3-1.2c0.3-6.1,0.6-12.7,0.7-20 C921.1,649.2,922,649.3,922.9,649.3L922.9,649.3z M933.6,650c-0.2,16.5-1.7,29.1-0.9,42c0,0.6-0.5,1.2-1.3,1.2 c-0.7,0-1.4-0.5-1.4-1.1c-0.8-12.9,0.7-25.7,0.9-42.3C931.8,649.8,932.7,649.9,933.6,650L933.6,650z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000036940519728302883520000011685680220887484314_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#1B1464"
    },
    d: " M826.4,691.6c13.3,6.8,20.1,5.5,38.5,2.9c11.3-1.6,21.1,0,30.5,1.7c9.6,1.8,18.9,3.7,28.9,2.7c7.4-0.8,13.2-3.6,17.3-5.9 c0.6-0.3,0.7-1,0.3-1.5c-0.4-0.5-1.2-0.6-1.7-0.3c-3.9,2.2-9.3,4.9-16.2,5.6c-9.7,1-18.7-0.9-28.1-2.6c-9.7-1.8-19.7-3.4-31.4-1.8 c-17.6,2.5-24.1,3.9-36.8-2.6c-0.6-0.3-1.4-0.1-1.7,0.4C825.7,690.6,825.8,691.3,826.4,691.6L826.4,691.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000036940519728302883520000011685680220887484314_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#4C3710"
    },
    d: " M596.4,885.1c0-23.2,7.7-208,8.2-217.7l0.1-10c2.1-27.7,3.9-53.9,18.2-74.4c13.6-19.4,20.7-34.7,27.2-56.3c2-6.8,4-13.9,7.5-20.3 c1.1-1.9,2.1-4,3.3-5.9c0.5-0.9,1.6-2.6,1.7-2.8c1.9-3.1,5.5-7.3,5.4-10.8c-0.1-3.3-3.7-4.5-7.3-4.8c-7.2-0.6-13.8,6.5-14.9,7.7 c-1,1.2-4.2,5.3-6,8c-5.6,8.4-8.7,17.6-12.6,26.5c-0.3,0.6-0.5,1.2-0.8,1.8c-0.4,0.9-2,3.4-4,4.7c-0.8,0.5-1.7,0.9-2.6,0.8 c-0.6,0-1.2-0.2-1.8-0.6c-1.1-0.8-1.9-1.9-2.4-3.1c-0.7-1.8-1-3.8-1.3-5.3c-2-8.4-1.2-17.1-1.2-25.5c-0.1-16.4-1.9-62-3.1-74.6 c-0.8-7.7-1.2-15.5-1.7-23.2c-0.4-5.4-0.5-10.7-1.6-16c-0.5-2.4-1-12.1-2.2-16.5c-0.7-2.5-0.6-5.1-2.4-7.3c-1-1.2-1.5-2-3-2.8 c-2.1-1.3-4.4-1.7-7.1-0.2c-0.8,0.4-1.5,0.9-2.1,1.5c-2,1.9-2.6,4.2-2.9,6.5c-0.4,4-1,7.9-0.8,12c0.3,5.3-0.3,10.5-0.1,15.6 c0.2,5.5,0.3,11.1,0.6,16.6c0.3,4.8,0.8,9.6,0.7,14.4c-0.1,5.1,0,10.3-0.4,15.5c0,0.6,0,39.3-0.6,40.4c-0.3,0.6-0.8,0.9-1.5,0.8 c-1,0-1.5-0.6-1.7-1.1c-0.4-1.3-0.7-39-0.6-40.4c0.1-5.5-0.2-10.9-0.4-16.8c-0.1-5,0.1-9.9-0.3-14.9c-0.4-5.3-0.4-10.8-0.7-16.2 c-0.2-3.2,0-6.4-0.2-9.6c-0.1-3.1-0.5-6.1-0.5-9.2c0.1-4.6-0.1-9.2-0.8-13.8c-0.3-2-0.8-4.7-2.8-6.2c-2.8-2-7.6-1.6-10.1,0.6 c-1.5,1.3-2.2,3-2.6,4.7c-1.2,5-2.1,10.3-2.3,15.4c-0.2,4.2-0.7,25-0.8,27.7c-0.3,6-0.1,11.8-0.3,17.8c-0.2,4.5-0.6,9.1-0.5,13.6 c0.1,3.3,0.3,43.3-0.4,46.5c-0.1,0.5-0.2,1.3-0.5,2c-0.2,0.5-0.5,1-1,1.2c-0.3,0.1-1.3,0.2-1.8-0.1c-0.3-0.2-0.6-0.8-0.8-1.5 c-0.2-0.8-0.3-1.7-0.2-2.4c0.1-1.6-0.1-40.5,0-41.7c0.4-5.4-0.4-22.7-0.2-25.8c0.1-2.3,0.3-4.6,0.3-6.9c0.2-5.6,0.1-11.1,0.2-16.7 c0.1-5.8,0.3-11.7-0.6-17.4c-0.4-2.5-0.9-5.3-2.4-7.5c-0.9-1.3-2.2-2-4.1-2.1c-2.3-0.1-4.5,0.5-5.8,1.7c-1.5,1.4-2.5,2.4-3.2,4.3 c-0.6,1.5-0.9,3.1-1.3,5c-0.2,1-0.3,2.2-0.5,3.3c-0.2,1.3-0.3,2.5-0.5,3.8c-0.4,4-0.5,9.8-0.8,13.8c-0.6,7.6-1.3,29.9-1.3,32.5 c0,1-0.8,50-1,53.1c-0.2,2.5,0.1,5.3-0.7,7.7c-0.1,0.4-0.3,1-0.7,1.4c-0.3,0.3-0.7,0.6-1.2,0.6c-0.5,0.1-1-0.1-1.3-0.5 c-0.5-0.5-0.9-1.2-0.9-1.6c-0.3-2.9-0.6-43.1-0.5-45.8c0.3-6.8,0.3-9.6,0.4-16.5c0-2-0.2-12.5-0.2-13.9c-0.1-2.1-0.1-4.1-0.1-6.2 c0-0.1,0-0.1,0.1-0.1c0-2,0-3.9,0.1-5.8c0.1-2.4,0.3-4.9-0.2-7.3c-0.4-1.7-1.1-3.3-2.5-4.6c-0.5-0.5-2.6-1.2-3.4-1.2 c-3.3-0.2-5,2-5.6,3.2c-0.8,1.7-1.7,3.4-2.2,5.1c-0.6,2.2-1.2,4.2-1.8,6.4c-1.4,4.9-1.5,10-2,15.1c-0.4,4-3.5,83.4-4,93.4 c-0.4,8.5-0.5,17-1.1,25.4c-0.6,8.3-1.7,16.6-1.9,24.9c-0.2,7,1,30.7,1.1,34.8c0.3,12.2,0.1,24.4,0.3,36.7 c0.2,13.7-0.4,27.4,0.1,41.1c0.4,13,2,25.9,2.1,38.9c0,4.9-3.4,168.2-3.2,177.2L596.4,885.1L596.4,885.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000050645323543157969050000015795141274272933803_",
    gradientUnits: "userSpaceOnUse",
    x1: 645.8342,
    y1: 771.4718,
    x2: 356.0224,
    y2: 773.9383
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2292,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000036940519728302883520000011685680220887484314_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000050645323543157969050000015795141274272933803_)"
    },
    d: " M634.6,903.8c0-19.2-10.4-84-8.3-105.5c1.6-16.9,5.6-31.5,3-51.7c-2-15.6-3.2-46.8-3.3-69.8c-0.1-15.4,2.2-25.8-2.2-30.6 c-4.2-4.5-25.5-5.3-49.2-5.9c-31.4-0.8-67,0.1-71.9,4.6c-8.1,7.5-0.5,28.2-3.6,48.2c-3.9,24.6-8.9,53.3-7.8,80.4 c1,23.9,5.5,115.3,1.4,130.8l139.7-1.2L634.6,903.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000036940519728302883520000011685680220887484314_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#2E3192"
    },
    d: " M627.8,731.4c-1.8-0.1-3.6-0.2-5.5-0.4c-11.8-0.9-23.6-1.5-35.4-2.2c-26.4-1.7-53-1.4-79.5-1.5c-4.5,0-9-0.2-13.6-0.4 c0.1-0.7,0.2-1.5,0.3-2.2c4.4,0.2,8.9,0.3,13.3,0.4c26.6,0.1,53.2-0.2,79.7,1.5c11.8,0.8,23.6,1.4,35.4,2.2c1.7,0.1,3.4,0.2,5,0.3 C627.7,729.9,627.8,730.7,627.8,731.4L627.8,731.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000036940519728302883520000011685680220887484314_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#2E3192"
    },
    d: " M605.9,709.7l-10.8-0.5c-0.6,0-1.2,0.5-1.2,1.1c0,0.6,0.5,1.2,1.1,1.2l10.8,0.5c0.6,0,1.2-0.5,1.2-1.1 C607.1,710.2,606.6,709.7,605.9,709.7L605.9,709.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000036940519728302883520000011685680220887484314_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#2E3192"
    },
    d: " M605.6,685.2l-10.8-0.5c-0.6,0-1.2,0.5-1.2,1.1c0,0.6,0.5,1.2,1.1,1.2l10.8,0.5c0.6,0,1.2-0.5,1.2-1.1 C606.7,685.7,606.2,685.2,605.6,685.2L605.6,685.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000036940519728302883520000011685680220887484314_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#2E3192"
    },
    d: " M604.9,660.3l-10.8-0.5c-0.6,0-1.2,0.5-1.2,1.1c0,0.6,0.5,1.2,1.1,1.2l10.8,0.5c0.6,0,1.2-0.5,1.2-1.1 C606,660.9,605.5,660.3,604.9,660.3L604.9,660.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000036940519728302883520000011685680220887484314_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#2E3192"
    },
    d: " M612.9,712.9c-1.1,3-4.4,4.5-7.3,3.4c-3-1.1-4.5-4.4-3.4-7.3c1.1-3,4.4-4.5,7.3-3.4C612.5,706.7,614,710,612.9,712.9L612.9,712.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000036940519728302883520000011685680220887484314_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#2E3192"
    },
    d: " M612.2,688.3c-1.1,3-4.4,4.5-7.3,3.4c-3-1.1-4.5-4.4-3.4-7.3c1.1-3,4.4-4.5,7.3-3.4C611.7,682.1,613.3,685.3,612.2,688.3 L612.2,688.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000036940519728302883520000011685680220887484314_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#2E3192"
    },
    d: " M610.8,663.9c-1.1,3-4.4,4.5-7.3,3.4c-3-1.1-4.5-4.4-3.4-7.3c1.1-3,4.4-4.5,7.3-3.4C610.3,657.7,611.9,661,610.8,663.9L610.8,663.9 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000036940519728302883520000011685680220887484314_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#754C24"
    },
    d: " M689.2,677c-1.2-23.2-4.5-156.4-5.4-166.1l-0.6-10c-3.1-27.6-8.8-53.5-20.9-73.4c-11.4-18.9-17.7-33.8-23.8-55.1 c-1.9-6.7-3.8-13.7-6.8-20c-0.9-1.9-1.8-3.9-2.8-5.7c-0.4-0.9-1.4-2.5-1.5-2.8c-1.6-3-4.6-7.1-4.7-10.6c-0.1-3.3,2.6-4.7,5.3-5.1 c5.5-0.9,11,6,11.9,7.1c0.8,1.1,3.5,5.1,5,7.7c4.7,8.2,7.6,17.3,11.1,26c0.2,0.6,0.5,1.2,0.7,1.8c0.4,0.9,1.7,3.3,3.3,4.5 c0.7,0.5,1.4,0.8,2,0.7c0.5-0.1,0.9-0.3,1.4-0.7c0.8-0.9,1.3-2,1.7-3.2c0.5-1.8,0.5-3.8,0.7-5.3c1.1-8.4,0-17.1-0.4-25.5 c-0.8-16.3,0.1-25.4,0.4-37.9c0.2-7.7,0.1-15.5,0.1-23.3c0-5.4-0.2-10.7,0.4-16.1c0.2-2.4,0.2-12.1,0.8-16.6 c0.4-2.6,0.2-5.1,1.4-7.4c0.7-1.2,1.1-2,2.1-3c1.6-1.3,3.3-1.9,5.4-0.5c0.6,0.4,1.2,0.8,1.7,1.4c1.6,1.8,2.2,4.1,2.5,6.4 c0.5,3.9,1.2,7.8,1.2,11.9c0.1,5.3,0.8,10.4,0.9,15.6c0.2,5.5,0.4,11.1,0.4,16.6c0,4.8-0.1,9.6,0.2,14.4c0.3,5.1,0.5,10.3,1.1,15.4 c0.1,0.6,0.1,2.5,0.6,3.6c0.3,0.5,0.6,0.8,1.2,0.8c0.8-0.1,1.1-0.7,1.2-1.2c0.3-1.3,0.4-2.3,0.3-3.7c-0.4-5.5-0.4-10.9-0.6-16.8 c-0.2-5-0.6-9.9-0.5-14.8c0-5.3-0.2-10.8-0.3-16.2c0-3.2-0.3-6.4-0.4-9.6c-0.1-3.1,0.1-6.1-0.1-9.2c-0.3-4.6-0.4-9.2-0.1-13.8 c0.1-2,0.3-4.8,1.8-6.3c2.1-2.1,5.7-1.9,7.8,0.2c1.2,1.2,1.8,2.9,2.2,4.6c1.2,4.9,2.1,10.2,2.5,15.3c0.3,4.2,1.8,25,2.1,27.6 c0.5,5.9,0.7,11.8,1.2,17.7c0.4,4.5,0.9,9,1.1,13.5c0.1,3.3,0.1,6.6,0.9,9.8c0.1,0.5,0.2,1.3,0.5,2c0.2,0.5,0.5,0.9,0.8,1.1 c0.3,0.1,1,0.2,1.4-0.2c0.3-0.2,0.5-0.8,0.5-1.5c0.1-0.8,0.1-1.8,0-2.4c-0.1-1.6-0.1-3.8-0.2-5c-0.6-5.4-0.9-22.7-1.2-25.7 c-0.2-2.3-0.4-4.6-0.6-6.8c-0.4-5.5-0.7-11-1-16.7c-0.4-5.8-0.8-11.7-0.4-17.4c0.2-2.5,0.4-5.4,1.5-7.6c0.6-1.3,1.6-2.1,3.1-2.3 c1.8-0.2,3.5,0.3,4.6,1.5c1.2,1.3,2,2.3,2.7,4.2c0.5,1.4,0.9,3,1.3,4.9c0.2,1,0.4,2.2,0.5,3.2c0.2,1.3,0.4,2.5,0.5,3.8 c0.5,4,0.9,9.8,1.3,13.8c0.9,7.6,2.6,29.8,2.7,32.4c0,1,1.3,13.2,1.7,16.3c0.3,2.5,0.2,5.3,0.9,7.7c0.1,0.4,0.3,1,0.6,1.4 c0.2,0.3,0.5,0.5,0.9,0.6c0.4,0,0.7-0.2,1-0.5c0.4-0.5,0.6-1.2,0.6-1.7c0.1-2.9,0.1-6.4-0.1-9.1c-0.6-6.8-0.8-9.6-1.2-16.4 c-0.1-2-0.5-12.5-0.6-13.9c-0.1-2.1-0.1-4.1-0.2-6.2c0-0.1,0-0.1-0.1-0.1c-0.1-1.9-0.2-3.9-0.4-5.8c-0.2-2.4-0.5-4.9-0.2-7.3 c0.2-1.7,0.7-3.3,1.7-4.7c0.4-0.5,1.9-1.3,2.6-1.4c2.5-0.4,3.9,1.7,4.5,3c0.7,1.7,1.5,3.3,1.9,5c0.5,2.2,1.1,4.1,1.7,6.3 c1.3,4.8,1.7,9.9,2.3,15c0.5,4,5.1,46.5,6,56.5c0.7,8.4,1.3,16.9,2.2,25.3c0.9,8.3,2.2,16.5,2.8,24.8c0.5,7,0.8,30.7,1,34.8 c0.4,12.2,1.2,24.4,1.7,36.6c0.6,13.7,1.7,27.4,2.1,41.1c0.3,13-0.2,26,0.4,38.9c0.2,4.9,2.1,116.7,2.4,125.8L689.2,677L689.2,677z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010278054658039446380000015170230938880696715_",
    gradientUnits: "userSpaceOnUse",
    x1: 658.3813,
    y1: 488.4454,
    x2: 836.8323,
    y2: 481.7535
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2292,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000036940519728302883520000011685680220887484314_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000010278054658039446380000015170230938880696715_)"
    },
    d: " M759.4,466.7c-3.5-0.2-10.2,1.8-18.3,3.8c-6.9,1.7-14.1,2.7-21.8,3.8c-11.3,1.6-24,1.4-34.2,1.3c-4.7,0-7.3,0.4-10.9,3.3 c-3.1,2.5-3.4,9.3-2.5,14.7c0.5,2.8,2,6.2,4.5,8c3.2,2.2,5.6,2.7,10.5,2.9c12.2,0.5,25.3,0.4,36-1.3c18-2.8,39.7-8.1,44.3-13.5 c1.6-1.9,1.6-6.3,0.3-11.1C765.8,472.9,766,467,759.4,466.7L759.4,466.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000036940519728302883520000011685680220887484314_)",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: " M686.1,497.9c3.1,0.2,6,0.5,10.9,0.2c3.1-0.2,5.4-2.8,5.2-5.9c-0.2-3.1-2.8-5.4-5.9-5.2c-4.4,0.3-6.9,0-9.7-0.2 c-3.1-0.2-5.7,2.2-5.8,5.2C680.6,495.2,683,497.8,686.1,497.9L686.1,497.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000012431921036557241260000009358211456864105907_",
    gradientUnits: "userSpaceOnUse",
    x1: 662.045,
    y1: 737.4525,
    x2: 867.2636,
    y2: 729.6453
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2292,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000036940519728302883520000011685680220887484314_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000012431921036557241260000009358211456864105907_)"
    },
    d: " M682.3,904c-8.1-30-5.1-129.2-5.1-146.9c0-17.5-0.6-22.3,0.4-46.2c1.5-36.7-4.9-39.7-2.5-63.4c1.7-17.2,5.5-28.8,3.8-47 c-1.5-16.2-6.1-25.5-0.2-29.7c5.9-4.2,18.9,3.3,39.7,4.2c7.7,0.3,18.3-1.1,26.8-3.7c7.9-2.4,13.9-7.8,19.3-4.2 c5.1,3.4,2.6,16.8,2.6,29.7c0,21.9,0.6,37.2,4.8,64.3c2.1,13.6-0.2,25-0.7,38.7c-0.4,11.4,1.2,24.6-0.6,39.4 c-4.3,35.2,3.8,154.7,4.7,159.9l-90.7,5.4L682.3,904z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000036940519728302883520000011685680220887484314_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FF931E"
    },
    d: " M756.7,530.4c0.6,0.4,1.1,0.8,1.7,1.3c5.1,4.1,7.6,8.7,6.9,12.9c-0.7,4.2-4.6,7.6-10.8,9.8c-8.7,3-22,3.7-36.4,1.2 s-26.7-7.6-33.9-13.4c-5.1-4.1-7.6-8.7-6.9-12.9c0.6-3.3,3.1-6.1,7.1-8.2c0,0.8,0.1,1.6,0.1,2.5c-2.7,1.6-4.5,3.6-4.9,6 c-0.6,3.5,1.8,7.2,6.1,10.7c6.9,5.6,18.9,10.5,32.8,13c14,2.4,26.9,1.9,35.3-1.1c5.2-1.8,8.7-4.5,9.3-8c0.6-3.5-1.8-7.2-6.1-10.7 c-0.1-0.1-0.1-0.1-0.2-0.2C756.7,532.3,756.7,531.4,756.7,530.4L756.7,530.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000036940519728302883520000011685680220887484314_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FF931E"
    },
    d: " M756.7,517.2c2.5,1.4,4.6,2.8,6.2,4.3c3.6,3.2,5.3,6.7,4.9,10c-0.4,3.3-2.8,6.3-7.2,8.5c-8.2,4.2-24,6-41.6,3.8 c-17.6-2.2-32.4-7.8-39.4-13.9c-3.6-3.2-5.3-6.7-4.9-10c0.4-3.3,2.8-6.3,7.2-8.5c0.6-0.3,1.1-0.6,1.8-0.8l0,0.4 c0.1,0.8,0.2,2.6,0.3,5.1c-0.8,0.5-1.6,0.9-2.2,1.5c-1.1,0.9-1.8,1.9-2,3c-0.1,1.1,0.3,2.2,1.2,3.4c1.1,1.5,2.8,3,5,4.4 c7.3,4.7,19.5,8.6,33.6,10.4c14.1,1.8,26.9,1,35.1-1.8c2.5-0.8,4.5-1.8,6-3c1.1-0.9,1.8-1.9,2-3c0.1-1.1-0.3-2.2-1.2-3.4 c-1.1-1.5-2.8-2.9-4.9-4.3C756.8,521.2,756.8,519.2,756.7,517.2L756.7,517.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000036940519728302883520000011685680220887484314_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#8C6239"
    },
    d: " M382.4,713.6L453,715c0,0-1-210.3-0.6-218.4l0.2-10c2-27.7,6.7-53.8,18-74.1c10.7-19.3,16.4-34.5,21.7-56 c1.6-6.7,3.3-13.9,6.1-20.2c0.8-1.9,1.6-3.9,2.6-5.8c0.4-0.9,1.3-2.6,1.4-2.8c1.5-3,4.4-7.3,4.3-10.7c0-3.3-2.8-4.5-5.5-4.9 c-5.5-0.7-10.7,6.4-11.6,7.6c-0.8,1.2-3.3,5.2-4.7,7.9c-4.4,8.4-6.9,17.5-10.1,26.4c-0.2,0.6-0.4,1.2-0.7,1.8 c-0.4,0.9-1.6,3.4-3.1,4.6c-0.6,0.5-1.3,0.9-2,0.8c-0.5,0-0.9-0.2-1.4-0.7c-0.9-0.8-1.4-1.9-1.8-3.2c-0.5-1.8-0.7-3.8-0.9-5.3 c-1.4-8.4-0.7-17.1-0.6-25.5c0.1-16.4-1.1-25.3-1.9-37.9c-0.5-7.7-0.7-15.5-1-23.3c-0.2-5.4-0.3-10.7-1-16 c-0.3-2.4-0.6-12.1-1.5-16.5c-0.5-2.5-0.4-5.1-1.7-7.3c-0.7-1.2-1.1-2-2.2-2.9c-1.6-1.3-3.4-1.8-5.5-0.3c-0.6,0.4-1.1,0.9-1.6,1.5 c-1.5,1.9-2.1,4.2-2.3,6.5c-0.4,4-0.9,7.9-0.8,12c0.2,5.3-0.3,10.5-0.3,15.6c0.1,5.5,0.1,11.1,0.2,16.6c0.2,4.8,0.5,9.6,0.4,14.4 c-0.1,5.1-0.1,10.3-0.5,15.5c0,0.6,0,2.5-0.5,3.6c-0.2,0.5-0.6,0.9-1.1,0.8c-0.8,0-1.1-0.6-1.3-1.1c-0.3-1.3-0.5-2.3-0.4-3.7 c0.2-5.5,0-11-0.1-16.8c0-5,0.2-9.9,0-14.9c-0.2-5.3-0.2-10.8-0.3-16.2c-0.1-3.2,0.1-6.4,0-9.6c-0.1-3.1-0.3-6.1-0.2-9.2 c0.1-4.6,0-9.2-0.4-13.8c-0.2-2-0.5-4.7-2.1-6.2c-2.2-2-5.8-1.7-7.8,0.5c-1.2,1.3-1.7,3-2.1,4.7c-1,4.9-1.7,10.3-1.9,15.4 c-0.2,4.2-0.8,25-1,27.7c-0.3,5.9-0.2,11.8-0.5,17.8c-0.2,4.5-0.6,9.1-0.6,13.6c0,3.3,0.1,6.6-0.5,9.8c-0.1,0.5-0.2,1.3-0.4,2 c-0.2,0.5-0.4,1-0.8,1.2c-0.3,0.1-1,0.2-1.4-0.1c-0.3-0.2-0.5-0.8-0.6-1.5c-0.2-0.8-0.2-1.8-0.1-2.4c0.1-1.6,0-3.8,0-5 c0.4-5.4,0-22.7,0.2-25.8c0.1-2.3,0.3-4.6,0.3-6.9c0.2-5.6,0.2-11.1,0.4-16.7c0.1-5.8,0.4-11.7-0.2-17.4c-0.3-2.5-0.6-5.4-1.8-7.6 c-0.7-1.3-1.6-2.1-3.1-2.2c-1.8-0.1-3.5,0.4-4.5,1.6c-1.2,1.3-1.9,2.3-2.5,4.3c-0.4,1.5-0.8,3.1-1.1,5c-0.2,1-0.3,2.2-0.4,3.3 c-0.1,1.3-0.3,2.5-0.4,3.8c-0.4,4-0.5,9.8-0.8,13.8c-0.6,7.6-1.4,29.9-1.4,32.5c0,1-0.8,13.2-1,16.4c-0.2,2.5,0,5.3-0.6,7.7 c-0.1,0.4-0.3,1-0.6,1.4c-0.2,0.3-0.5,0.5-0.9,0.6c-0.4,0.1-0.7-0.1-1-0.5c-0.4-0.5-0.7-1.2-0.7-1.6c-0.2-2.9-0.4-6.4-0.3-9.1 c0.3-6.8,0.4-9.6,0.5-16.5c0-2,0-12.5,0-13.9c0-2.1,0-4.1,0-6.2c0-0.1,0-0.1,0.1-0.1c0-1.9,0.1-3.9,0.1-5.8 c0.1-2.4,0.3-4.9-0.1-7.3c-0.3-1.7-0.8-3.3-1.9-4.7c-0.4-0.5-2-1.2-2.6-1.3c-2.5-0.3-3.9,1.9-4.4,3.1c-0.7,1.7-1.4,3.4-1.8,5.1 c-0.5,2.2-1,4.2-1.5,6.4c-1.1,4.9-1.3,10-1.7,15.1c-0.4,4-3.3,46.7-3.8,56.7c-0.4,8.5-0.6,16.9-1.2,25.4 c-0.6,8.3-1.5,16.6-1.8,24.9c-0.2,7,0.4,30.7,0.4,34.8c0,12.2-0.2,24.4-0.3,36.6c0,13.7-0.6,27.4-0.5,41.1 c0.2,13,1.2,25.9,1.1,38.9C380.7,539.8,382.4,713.6,382.4,713.6L382.4,713.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000128453007409577635620000002191893446913897606_",
    gradientUnits: "userSpaceOnUse",
    x1: 305.5795,
    y1: 743.9971,
    x2: 549.8342,
    y2: 742.8818
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2292,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000036940519728302883520000011685680220887484314_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000128453007409577635620000002191893446913897606_)"
    },
    d: " M471,924.5c2.5-26.5,5.6-165.2,4.4-187.9c-1.7-30.1,1.1-36.5-2-70.4c-1.2-13.4-2.6-16.7-3.6-28.3c-1.7-19.4-4.2-36-3.3-52.1 c0.4-6.4,0.4-16.7-3.8-20.8c-5.3-5.2-21.9-1.4-26.8-1.2c-8.4,0.3-25.2-0.1-41.3-1.1c-8.3-0.5-14.6-0.2-19.3-0.3 c-4.1-0.1-6.6-0.7-8.8,1.8c-1.9,2.1-1.8,5.9-2,11.7c-0.2,4.5-0.9,10.6-0.7,15.9c0.8,17.4,4.6,36,2,53.6c-1.2,7.6-1.8,13.3-1.6,21.1 c0.2,13,0.9,27.5,0.2,40.6c-1.3,23.2,0.7,31.6,5.9,56.4c4.2,19.6-8.1,161.7-8.1,161.7s80.8-3,105.4-0.8L471,924.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000036940519728302883520000011685680220887484314_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FF7BAC"
    },
    d: " M438.6,659.1c1.6-0.2,3.1,0.9,3.3,2.6c0.2,1.6-0.9,3.1-2.6,3.3c-1.6,0.2-3.1-0.9-3.3-2.6C435.9,660.8,437,659.3,438.6,659.1 L438.6,659.1z M398,662.7c1.6-0.2,3.1,0.9,3.3,2.6c0.2,1.6-0.9,3.1-2.6,3.3c-1.6,0.2-3.1-0.9-3.3-2.6 C395.2,664.4,396.4,662.9,398,662.7L398,662.7z M451.8,633.8c1.6-0.2,3.1,0.9,3.3,2.6c0.2,1.6-0.9,3.1-2.6,3.3 c-1.6,0.2-3.1-0.9-3.3-2.6C449,635.5,450.2,634,451.8,633.8L451.8,633.8z M415.6,635.4c1.6-0.2,3.1,0.9,3.3,2.6 c0.2,1.6-0.9,3.1-2.6,3.3c-1.6,0.2-3.1-0.9-3.3-2.6C412.9,637.1,414,635.6,415.6,635.4L415.6,635.4z M381.4,639 c1.6-0.2,3.1,0.9,3.3,2.6c0.2,1.6-0.9,3.1-2.6,3.3c-1.6,0.2-3.1-0.9-3.3-2.6C378.7,640.7,379.8,639.2,381.4,639L381.4,639z  M436.6,611.8c1.6-0.2,3.1,0.9,3.3,2.6c0.2,1.6-0.9,3.1-2.6,3.3c-1.6,0.2-3.1-0.9-3.3-2.6C433.9,613.4,435,612,436.6,611.8 L436.6,611.8z M398.1,613.1c1.6-0.2,3.1,0.9,3.3,2.6c0.2,1.6-0.9,3.1-2.6,3.3c-1.6,0.2-3.1-0.9-3.3-2.6 C395.4,614.8,396.5,613.3,398.1,613.1L398.1,613.1z M415.2,589.5c1.6-0.2,3.1,0.9,3.3,2.6c0.2,1.6-0.9,3.1-2.6,3.3 c-1.6,0.2-3.1-0.9-3.3-2.6C412.5,591.2,413.6,589.7,415.2,589.5L415.2,589.5z M448.3,585.8c1.6-0.2,3.1,0.9,3.3,2.6 c0.2,1.6-0.9,3.1-2.6,3.3c-1.6,0.2-3.1-0.9-3.3-2.6C445.5,587.5,446.7,586,448.3,585.8L448.3,585.8z M382.5,592.8 c1.6-0.2,3.1,0.9,3.3,2.6c0.2,1.6-0.9,3.1-2.6,3.3c-1.6,0.2-3.1-0.9-3.3-2.6C379.7,594.5,380.9,593,382.5,592.8L382.5,592.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000036940519728302883520000011685680220887484314_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FF7BAC"
    },
    d: " M441.9,757c1.6-0.2,3.1,0.9,3.3,2.6c0.2,1.6-0.9,3.1-2.6,3.3c-1.6,0.2-3.1-0.9-3.3-2.6C439.1,758.7,440.3,757.2,441.9,757 L441.9,757z M401.2,760.6c1.6-0.2,3.1,0.9,3.3,2.6c0.2,1.6-0.9,3.1-2.6,3.3c-1.6,0.2-3.1-0.9-3.3-2.6 C398.5,762.3,399.6,760.8,401.2,760.6L401.2,760.6z M455.1,731.7c1.6-0.2,3.1,0.9,3.3,2.6c0.2,1.6-0.9,3.1-2.6,3.3 c-1.6,0.2-3.1-0.9-3.3-2.6C452.3,733.4,453.4,731.9,455.1,731.7L455.1,731.7z M418.9,733.4c1.6-0.2,3.1,0.9,3.3,2.6 c0.2,1.6-0.9,3.1-2.6,3.3c-1.6,0.2-3.1-0.9-3.3-2.6C416.1,735,417.2,733.6,418.9,733.4L418.9,733.4z M384.7,736.9 c1.6-0.2,3.1,0.9,3.3,2.6c0.2,1.6-0.9,3.1-2.6,3.3c-1.6,0.2-3.1-0.9-3.3-2.6C381.9,738.6,383.1,737.1,384.7,736.9L384.7,736.9z  M439.9,709.7c1.6-0.2,3.1,0.9,3.3,2.6c0.2,1.6-0.9,3.1-2.6,3.3c-1.6,0.2-3.1-0.9-3.3-2.6C437.1,711.4,438.3,709.9,439.9,709.7 L439.9,709.7z M401.4,711c1.6-0.2,3.1,0.9,3.3,2.6c0.2,1.6-0.9,3.1-2.6,3.3c-1.6,0.2-3.1-0.9-3.3-2.6 C398.6,712.7,399.8,711.2,401.4,711L401.4,711z M418.5,687.5c1.6-0.2,3.1,0.9,3.3,2.6c0.2,1.6-0.9,3.1-2.6,3.3 c-1.6,0.2-3.1-0.9-3.3-2.6C415.7,689.1,416.9,687.7,418.5,687.5L418.5,687.5z M451.5,683.7c1.6-0.2,3.1,0.9,3.3,2.6 c0.2,1.6-0.9,3.1-2.6,3.3c-1.6,0.2-3.1-0.9-3.3-2.6C448.8,685.4,449.9,683.9,451.5,683.7L451.5,683.7z M385.7,690.7 c1.6-0.2,3.1,0.9,3.3,2.6c0.2,1.6-0.9,3.1-2.6,3.3c-1.6,0.2-3.1-0.9-3.3-2.6C383,692.4,384.1,690.9,385.7,690.7L385.7,690.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000036940519728302883520000011685680220887484314_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FF7BAC"
    },
    d: " M441.9,857.2c1.6-0.2,3.1,0.9,3.3,2.6c0.2,1.6-0.9,3.1-2.6,3.3c-1.6,0.2-3.1-0.9-3.3-2.6C439.1,858.8,440.3,857.4,441.9,857.2 L441.9,857.2z M401.2,860.8c1.6-0.2,3.1,0.9,3.3,2.6c0.2,1.6-0.9,3.1-2.6,3.3c-1.6,0.2-3.1-0.9-3.3-2.6 C398.5,862.5,399.6,861,401.2,860.8L401.2,860.8z M455.1,831.9c1.6-0.2,3.1,0.9,3.3,2.6c0.2,1.6-0.9,3.1-2.6,3.3 c-1.6,0.2-3.1-0.9-3.3-2.6C452.3,833.5,453.4,832.1,455.1,831.9L455.1,831.9z M418.9,833.5c1.6-0.2,3.1,0.9,3.3,2.6 c0.2,1.6-0.9,3.1-2.6,3.3c-1.6,0.2-3.1-0.9-3.3-2.6C416.1,835.2,417.2,833.7,418.9,833.5L418.9,833.5z M384.7,837 c1.6-0.2,3.1,0.9,3.3,2.6c0.2,1.6-0.9,3.1-2.6,3.3c-1.6,0.2-3.1-0.9-3.3-2.6C381.9,838.7,383.1,837.2,384.7,837L384.7,837z  M439.9,809.8c1.6-0.2,3.1,0.9,3.3,2.6c0.2,1.6-0.9,3.1-2.6,3.3c-1.6,0.2-3.1-0.9-3.3-2.6C437.1,811.5,438.3,810,439.9,809.8 L439.9,809.8z M401.4,811.2c1.6-0.2,3.1,0.9,3.3,2.6c0.2,1.6-0.9,3.1-2.6,3.3c-1.6,0.2-3.1-0.9-3.3-2.6 C398.6,812.8,399.8,811.4,401.4,811.2L401.4,811.2z M418.5,787.6c1.6-0.2,3.1,0.9,3.3,2.6c0.2,1.6-0.9,3.1-2.6,3.3 c-1.6,0.2-3.1-0.9-3.3-2.6C415.7,789.3,416.9,787.8,418.5,787.6L418.5,787.6z M451.5,783.8c1.6-0.2,3.1,0.9,3.3,2.6 c0.2,1.6-0.9,3.1-2.6,3.3c-1.6,0.2-3.1-0.9-3.3-2.6C448.8,785.5,449.9,784,451.5,783.8L451.5,783.8z M385.7,790.8 c1.6-0.2,3.1,0.9,3.3,2.6c0.2,1.6-0.9,3.1-2.6,3.3c-1.6,0.2-3.1-0.9-3.3-2.6C383,792.5,384.1,791,385.7,790.8L385.7,790.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000036940519728302883520000011685680220887484314_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FF7BAC"
    },
    d: " M439.9,910c1.6-0.2,3.1,0.9,3.3,2.6c0.2,1.6-0.9,3.1-2.6,3.3c-1.6,0.2-3.1-0.9-3.3-2.6C437.1,911.6,438.3,910.2,439.9,910 L439.9,910z M401.4,911.3c1.6-0.2,3.1,0.9,3.3,2.6c0.2,1.6-0.9,3.1-2.6,3.3c-1.6,0.2-3.1-0.9-3.3-2.6 C398.6,913,399.8,911.5,401.4,911.3L401.4,911.3z M418.5,887.7c1.6-0.2,3.1,0.9,3.3,2.6c0.2,1.6-0.9,3.1-2.6,3.3 c-1.6,0.2-3.1-0.9-3.3-2.6C415.7,889.4,416.9,888,418.5,887.7L418.5,887.7z M451.5,884c1.6-0.2,3.1,0.9,3.3,2.6 c0.2,1.6-0.9,3.1-2.6,3.3c-1.6,0.2-3.1-0.9-3.3-2.6C448.8,885.7,449.9,884.2,451.5,884L451.5,884z M385.7,891 c1.6-0.2,3.1,0.9,3.3,2.6c0.2,1.6-0.9,3.1-2.6,3.3c-1.6,0.2-3.1-0.9-3.3-2.6C383,892.7,384.1,891.2,385.7,891L385.7,891z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000036940519728302883520000011685680220887484314_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#4A2E2E"
    },
    d: " M452.3,520.8v0.3c-0.6,0.5-1.2,1.1-1.9,1.6c-3.7,14.7-19.7,26-37.5,22.3c-0.4-0.1-0.7-0.3-0.8-0.7c-0.1-0.3-0.1-0.7,0.1-1.1 c7.4-11.9,19-20.7,36.6-22.1c1.2-1.1,2.4-2.1,3.6-3.2L452.3,520.8L452.3,520.8z M443.7,524.1c-0.6,0.1-1.3,0.2-1.9,0.4 c0.1,0.1,0.2,0.3,0.2,0.5c0.1,0.6-0.4,1.1-0.9,1.2c-0.6,0.1-1.1-0.4-1.2-0.9c0-0.1,0-0.2,0-0.2c-1.2,0.3-2.3,0.7-3.5,1.1 c0.2,0.2,0.3,0.4,0.4,0.7c0.1,0.6-0.4,1.1-0.9,1.2c-0.6,0.1-1.1-0.4-1.2-0.9c0-0.1,0-0.2,0-0.2c-2.3,0.9-4.4,2-6.4,3.3 c-3,1.9-5.6,4-8,6.5c0.6,0,1.1,0.4,1.1,0.9c0.1,0.6-0.4,1.1-0.9,1.2c-0.6,0.1-1.1-0.4-1.2-0.9c0,0,0-0.1,0-0.1 c-1.6,1.7-3,3.6-4.3,5.5c5.8,0.9,11.4,0.1,16.3-2c-0.3-0.2-0.5-0.5-0.6-0.8c-0.1-0.6,0.4-1.1,0.9-1.2c0.6-0.1,1.1,0.4,1.2,0.9 c0,0.1,0,0.2,0,0.4c3.6-1.7,6.8-4.1,9.3-7c-0.1,0-0.2,0-0.2,0.1c-0.6,0.1-1.1-0.4-1.2-0.9c-0.1-0.6,0.4-1.1,0.9-1.2 c0.6-0.1,1.1,0.4,1.2,0.9c0,0.1,0,0.2,0,0.3c0.6-0.7,1.1-1.4,1.6-2.1c-0.4-0.1-0.8-0.5-0.9-0.9c-0.1-0.6,0.4-1.1,0.9-1.2 c0.4,0,0.8,0.1,1,0.4c0.3-0.5,0.6-1.1,0.9-1.6c-0.3,0-0.6-0.2-0.8-0.5c-0.9,0.7-1.8,1.4-2.7,2.1c0.3,0.2,0.4,0.4,0.5,0.8 c0.1,0.6-0.4,1.1-0.9,1.2c-0.5,0.1-1-0.3-1.1-0.7c-0.5,0.4-1.1,0.8-1.6,1.2c0.4,0.1,0.7,0.5,0.8,0.9c0.1,0.6-0.4,1.1-0.9,1.2 c-0.6,0.1-1.1-0.4-1.2-0.9c0-0.1,0-0.1,0-0.2c-5.2,3.6-10.2,6.6-14.5,8.5c-0.6,0.3-1.2,0-1.5-0.6c-0.3-0.6,0-1.2,0.6-1.5 c4.1-1.8,8.9-4.7,13.9-8.1c-0.6,0-1.1-0.4-1.1-1c-0.1-0.6,0.4-1.1,0.9-1.2s1.1,0.4,1.2,0.9c0,0.2,0,0.4-0.1,0.5 c2.2-1.6,4.4-3.2,6.6-5C444,524.7,443.8,524.5,443.7,524.1L443.7,524.1z M427.9,539.6c0.6-0.1,1.1,0.4,1.2,0.9 c0.1,0.6-0.4,1.1-0.9,1.2c-0.6,0.1-1.1-0.4-1.2-0.9C426.8,540.2,427.3,539.7,427.9,539.6L427.9,539.6z M418.6,540.5 c0.6-0.1,1.1,0.4,1.2,0.9c0.1,0.6-0.4,1.1-0.9,1.2c-0.6,0.1-1.1-0.4-1.2-0.9C417.6,541.1,418.1,540.6,418.6,540.5L418.6,540.5z  M434.2,535.6c0.6-0.1,1.1,0.4,1.2,0.9c0.1,0.6-0.4,1.1-0.9,1.2c-0.6,0.1-1.1-0.4-1.2-0.9C433.2,536.2,433.6,535.6,434.2,535.6 L434.2,535.6z M437.8,534c0.6-0.1,1.1,0.4,1.2,0.9c0.1,0.6-0.4,1.1-0.9,1.2c-0.6,0.1-1.1-0.4-1.2-0.9 C436.8,534.6,437.2,534.1,437.8,534L437.8,534z M425.2,532.9c0.6-0.1,1.1,0.4,1.2,0.9c0.1,0.6-0.4,1.1-0.9,1.2 c-0.6,0.1-1.1-0.4-1.2-0.9C424.2,533.5,424.6,533,425.2,532.9L425.2,532.9z M429.6,532.3c0.6-0.1,1.1,0.4,1.2,0.9 c0.1,0.6-0.4,1.1-0.9,1.2c-0.6,0.1-1.1-0.4-1.2-0.9C428.6,532.9,429,532.4,429.6,532.3L429.6,532.3z M434.2,529.4 c0.6-0.1,1.1,0.4,1.2,0.9c0.1,0.6-0.4,1.1-0.9,1.2c-0.6,0.1-1.1-0.4-1.2-0.9C433.2,530,433.6,529.4,434.2,529.4L434.2,529.4z  M430.6,529.2c0.6-0.1,1.1,0.4,1.2,0.9c0.1,0.6-0.4,1.1-0.9,1.2c-0.6,0.1-1.1-0.4-1.2-0.9C429.6,529.8,430,529.3,430.6,529.2 L430.6,529.2z M438.2,526.2c0.6-0.1,1.1,0.4,1.2,0.9c0.1,0.6-0.4,1.1-0.9,1.2c-0.6,0.1-1.1-0.4-1.2-0.9 C437.2,526.8,437.6,526.3,438.2,526.2L438.2,526.2z M380.3,517c1.2-2.8,2.4-5.6,3.7-8.3c-5.9-9.7-4.5-24.5,6.4-32.8 c0.3-0.2,0.7-0.3,1.1-0.2c0.4,0.1,0.6,0.4,0.7,0.8c1.4,5.3,1.8,10.7,0.8,16.1c2.9-4.6,6.1-9,9.5-13.4c1.3-14.6,14-28.9,31.7-29.4 c0.4,0,0.7,0.2,1,0.5c0.2,0.3,0.3,0.7,0.1,1.1c-5.1,13.3-14.9,24.5-31.4,29.7c-2.5,3.1-4.8,6.4-7,9.6c6.4-4.5,15.3-6.4,24.1-3.4 c0.4,0.1,0.6,0.4,0.7,0.8c0.1,0.4,0,0.8-0.3,1.1c-7.4,8.2-17.7,13.5-31.5,12.8c-0.1,0.2-0.2,0.4-0.3,0.6c-0.5,1-1,2-1.6,3 c-2.9,5.5-5.5,11.2-7.6,17.2C380.4,520.8,380.3,518.9,380.3,517L380.3,517z M389.9,495.7c1.7-5.7,1.7-11.3,0.5-16.9 c-4.1,3.6-6.5,8.4-7.3,13.2c-0.7,4.3-0.2,8.7,1.3,12.5c0.3-5.4,0.9-10,1.8-14.2c-0.1,0-0.1,0-0.2,0c-0.6,0.1-1.1-0.4-1.2-0.9 c-0.1-0.6,0.4-1.1,0.9-1.2c0.3,0,0.7,0.1,0.9,0.3c0.1-0.5,0.2-0.9,0.4-1.4c0.2-0.6,0.8-1,1.4-0.8c0.6,0.2,1,0.8,0.8,1.4 c-0.4,1.6-0.8,3.2-1.1,4.8c0.2-0.1,0.4-0.2,0.6-0.3c0.6-0.1,1.1,0.4,1.2,0.9c0.1,0.6-0.4,1.1-0.9,1.2c-0.5,0.1-0.9-0.2-1.1-0.6 c-0.2,1.2-0.4,2.4-0.6,3.7c0.6,0,1.1,0.4,1.1,1c0.1,0.6-0.4,1.1-0.9,1.2c-0.1,0-0.3,0-0.4,0c-0.1,0.5-0.1,1.1-0.1,1.7 c0,0,0,0,0.1,0c0.3,0,0.5,0,0.7,0.2c0.6-1.3,1.2-2.6,1.6-3.8c-0.5,0-0.9-0.4-1-0.9c-0.1-0.6,0.4-1.1,0.9-1.2 C389.5,495.6,389.7,495.6,389.9,495.7L389.9,495.7z M407,496.9c4.5-1.9,8.3-4.6,11.6-8c-5.7-1.5-11.2-0.8-16,1.2 c-2.4,1-4.5,2.4-6.4,4c0.3,0.2,0.5,0.5,0.5,0.8c0.1,0.6-0.4,1.1-0.9,1.2c-0.5,0.1-0.9-0.2-1.1-0.6c-0.3,0.3-0.6,0.7-0.9,1.1 c0.2,0.1,0.4,0.3,0.5,0.6c1.2-0.6,2.4-1.2,3.6-1.8c-0.1-0.1-0.1-0.2-0.1-0.4c-0.1-0.6,0.4-1.1,0.9-1.2c0.5-0.1,0.9,0.2,1.1,0.6 c2.3-1.1,4.6-2,6.8-2.9c-0.3-0.2-0.4-0.4-0.5-0.8c-0.1-0.6,0.4-1.1,0.9-1.2c0.6-0.1,1.1,0.4,1.2,0.9c0,0.1,0,0.3,0,0.4 c0.1,0,0.1-0.1,0.2-0.1c0.6-0.2,1.2,0.1,1.5,0.7c0.2,0.6-0.1,1.2-0.7,1.5c-2.2,0.8-4.5,1.7-6.7,2.7c0.3,0.2,0.5,0.5,0.6,0.8 c0.1,0.6-0.4,1.1-0.9,1.2c-0.6,0.1-1.1-0.4-1.2-0.9c0-0.1,0-0.3,0-0.4c-2.2,1-4.4,2.1-6.7,3.3c1.2-0.1,2.5-0.2,3.6-0.3c0,0,0,0,0,0 c-0.1-0.6,0.4-1.1,0.9-1.2c0.6-0.1,1.1,0.3,1.2,0.9c1.9-0.4,3.7-0.9,5.4-1.5c-0.4-0.1-0.6-0.5-0.7-0.9c-0.1-0.6,0.4-1.1,0.9-1.2 c0.6-0.1,1.1,0.4,1.2,0.9C407.1,496.6,407,496.8,407,496.9L407,496.9z M401.4,491.2c0.6-0.1,1.1,0.4,1.2,0.9 c0.1,0.6-0.4,1.1-0.9,1.2c-0.6,0.1-1.1-0.4-1.2-0.9C400.4,491.8,400.8,491.3,401.4,491.2L401.4,491.2z M412.8,489.7 c0.6-0.1,1.1,0.4,1.2,0.9c0.1,0.6-0.4,1.1-0.9,1.2c-0.6,0.1-1.1-0.4-1.2-0.9C411.8,490.3,412.2,489.8,412.8,489.7L412.8,489.7z  M388.8,482.8c0.6-0.1,1.1,0.4,1.2,0.9s-0.4,1.1-0.9,1.2c-0.6,0.1-1.1-0.4-1.2-0.9C387.8,483.4,388.2,482.9,388.8,482.8 L388.8,482.8z M421.1,468.8c5.1-4.7,8.8-10.4,11.4-16.6c-7.6,0.6-14.1,4-18.9,8.8c-0.4,0.4-0.8,0.8-1.2,1.2c0,0,0.1,0,0.2,0 c0.6-0.1,1.1,0.4,1.2,0.9c0.1,0.6-0.4,1.1-0.9,1.2c-0.6,0.1-1.1-0.4-1.2-0.9c0-0.1,0-0.2,0-0.2c-1.1,1.3-2,2.6-2.9,4 c0.1-0.1,0.3-0.1,0.4-0.2c0.6-0.1,1.1,0.4,1.2,0.9c0.1,0.6-0.4,1.1-0.9,1.2c-0.6,0.1-1.1-0.4-1.2-0.9c0-0.1,0-0.1,0-0.2 c-0.6,1-1.1,2-1.5,3.1c0.5,0.1,0.8,0.5,0.9,0.9c0.1,0.6-0.4,1.1-0.9,1.2c-0.2,0-0.5,0-0.7-0.1c-0.1,0.3-0.2,0.6-0.3,0.9 c0.3,0,0.5,0.2,0.6,0.4c0.7-0.8,1.4-1.7,2.1-2.5c-0.4-0.1-0.6-0.5-0.7-0.9c-0.1-0.6,0.4-1.1,0.9-1.2c0.4,0,0.8,0.2,1.1,0.5 c2.9-3.3,6-6.6,9.2-9.7c0.4-0.4,1.2-0.4,1.6,0c0.4,0.4,0.4,1.2,0,1.6c-0.6,0.6-1.1,1.1-1.7,1.7c0.5,0,1,0.4,1,1 c0.1,0.6-0.4,1.1-0.9,1.2c-0.6,0.1-1.1-0.4-1.2-0.9c0,0,0,0,0,0c-1.5,1.5-2.9,3.1-4.4,4.7c0.5,0,0.9,0.4,1,0.9 c0.1,0.6-0.4,1.1-0.9,1.2c-0.6,0.1-1.1-0.3-1.2-0.9c-0.8,0.9-1.7,1.9-2.5,2.8c0.3,0.2,0.6,0.5,0.6,0.9c0.1,0.6-0.4,1.1-0.9,1.2 c-0.4,0-0.8-0.1-1-0.5c-0.3,0.3-0.5,0.6-0.8,1c0.3,0.1,0.6,0.3,0.7,0.7c2.9-1.3,5.6-2.7,8-4.4c-0.5-0.1-0.9-0.4-0.9-0.9 c-0.1-0.6,0.4-1.1,0.9-1.2c0.6-0.1,1.1,0.4,1.2,0.9c0,0.1,0,0.2,0,0.3c0.8-0.6,1.6-1.3,2.4-1.9c-0.6,0-1.1-0.4-1.1-0.9 c-0.1-0.6,0.4-1.1,0.9-1.2c0.6-0.1,1.1,0.4,1.2,0.9C421.2,468.6,421.2,468.7,421.1,468.8L421.1,468.8z M412.3,472.5 c0.6-0.1,1.1,0.4,1.2,0.9c0.1,0.6-0.4,1.1-0.9,1.2c-0.6,0.1-1.1-0.4-1.2-0.9C411.2,473.1,411.7,472.5,412.3,472.5L412.3,472.5z  M417.1,467.1c0.6-0.1,1.1,0.4,1.2,0.9c0.1,0.6-0.4,1.1-0.9,1.2c-0.6,0.1-1.1-0.4-1.2-0.9C416.1,467.7,416.5,467.1,417.1,467.1 L417.1,467.1z M411.7,465.4c0.6-0.1,1.1,0.4,1.2,0.9c0.1,0.6-0.4,1.1-0.9,1.2c-0.6,0.1-1.1-0.4-1.2-0.9 C410.6,466,411.1,465.4,411.7,465.4L411.7,465.4z M424.6,459.9c0.6-0.1,1.1,0.4,1.2,0.9c0.1,0.6-0.4,1.1-0.9,1.2 c-0.6,0.1-1.1-0.4-1.2-0.9C423.6,460.5,424.1,459.9,424.6,459.9L424.6,459.9z M426.5,455.1c0.6-0.1,1.1,0.4,1.2,0.9 c0.1,0.6-0.4,1.1-0.9,1.2c-0.6,0.1-1.1-0.4-1.2-0.9C425.5,455.7,425.9,455.2,426.5,455.1L426.5,455.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000036940519728302883520000011685680220887484314_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#6B4926"
    },
    d: " M47.4,772.6c2.3-23.1,27.5-232.6,28.1-242.3l0.9-10c1.2-27.7-0.6-54.2-9.5-75.7c-8.4-20.4-12.4-36.1-15.2-58.1 c-0.9-6.9-1.7-14.1-3.7-20.8c-0.6-2-1.2-4.1-1.9-6.1c-0.3-0.9-1-2.7-1-2.9c-1.1-3.2-3.5-7.7-3.1-11.2c0.4-3.3,3.3-4.2,6-4.2 c5.5-0.1,9.9,7.6,10.7,8.9c0.6,1.3,2.7,5.5,3.8,8.4c3.4,8.8,4.9,18.2,7,27.4c0.1,0.6,0.3,1.3,0.5,1.9c0.2,1,1.2,3.5,2.6,4.9 c0.6,0.6,1.2,1,1.9,1c0.5,0,1-0.1,1.5-0.5c1-0.7,1.6-1.8,2.1-2.9c0.7-1.7,1.1-3.7,1.5-5.1c2.4-8.2,2.6-16.9,3.5-25.3 c1.7-16.3,4-25.1,6.1-37.4c1.3-7.6,2.5-15.3,3.6-23c0.8-5.3,1.5-10.6,2.8-15.8c0.6-2.3,2-11.9,3.3-16.2c0.8-2.5,0.9-5,2.5-7.1 c0.9-1.1,1.4-1.9,2.6-2.6c1.8-1.1,3.6-1.4,5.5,0.3c0.5,0.5,1,1,1.4,1.6c1.3,2,1.6,4.4,1.5,6.7c-0.1,4,0,7.9-0.6,12 c-0.8,5.2-0.8,10.4-1.5,15.5c-0.7,5.5-1.3,11-2.1,16.5c-0.7,4.8-1.6,9.5-2,14.3c-0.4,5.1-1,10.3-1.3,15.4c0,0.6-0.3,2.5,0.1,3.7 c0.2,0.6,0.5,0.9,1,0.9c0.8,0,1.2-0.5,1.4-1c0.5-1.3,0.7-2.3,0.9-3.6c0.5-5.5,1.3-10.9,2-16.7c0.6-5,0.9-9.8,1.7-14.8 c0.8-5.3,1.4-10.7,2.2-16c0.5-3.2,0.7-6.4,1.1-9.5c0.4-3,1-6.1,1.3-9.1c0.4-4.6,1-9.1,2-13.6c0.4-2,1.1-4.7,2.8-5.9 c2.4-1.8,5.9-1,7.7,1.3c1,1.4,1.4,3.2,1.5,4.9c0.4,5,0.6,10.5,0.2,15.5c-0.3,4.2-2,24.9-2.2,27.6c-0.4,5.9-1.1,11.8-1.5,17.7 c-0.3,4.5-0.4,9.1-1,13.6c-0.4,3.3-0.9,6.5-0.6,9.8c0,0.5,0,1.3,0.2,2.1c0.1,0.5,0.3,1,0.7,1.2c0.2,0.2,1,0.3,1.4,0.1 c0.3-0.2,0.6-0.7,0.8-1.4c0.2-0.8,0.4-1.7,0.4-2.4c0.1-1.6,0.5-3.8,0.5-5c0.2-5.4,2.5-22.6,2.7-25.6c0.2-2.3,0.3-4.6,0.4-6.9 c0.4-5.5,1-11,1.5-16.6c0.5-5.7,1-11.6,2.2-17.3c0.5-2.4,1.2-5.3,2.6-7.3c0.8-1.2,1.9-1.9,3.4-1.8c1.8,0.1,3.4,0.8,4.3,2.1 c1,1.5,1.7,2.5,2,4.6c0.3,1.5,0.4,3.1,0.5,5c0.1,1.1,0,2.2,0,3.3c0,1.3,0,2.5,0,3.8c-0.1,4-0.6,9.8-0.8,13.8 c-0.3,7.6-2,29.9-2.3,32.4c-0.1,1-0.7,13.3-0.8,16.4c-0.1,2.5-0.6,5.2-0.3,7.8c0.1,0.4,0.2,1,0.4,1.4c0.2,0.3,0.5,0.6,0.8,0.7 c0.4,0.1,0.7-0.1,1.1-0.4c0.4-0.4,0.8-1.1,0.9-1.6c0.5-2.8,1.1-6.3,1.3-9c0.4-6.8,0.7-9.6,1.3-16.4c0.2-2,1.4-12.4,1.5-13.8 c0.2-2.1,0.5-4.1,0.7-6.2c0-0.1,0-0.1,0-0.1c0.2-1.9,0.4-3.9,0.5-5.8c0.2-2.4,0.2-4.9,0.9-7.2c0.5-1.7,1.2-3.2,2.4-4.4 c0.5-0.5,2.1-1,2.8-1c2.5,0,3.6,2.3,4,3.6c0.5,1.8,1,3.5,1.2,5.3c0.2,2.2,0.5,4.3,0.7,6.5c0.5,5,0.1,10.1,0,15.2 c-0.1,4-2,46.7-2.6,56.7c-0.5,8.5-1.3,16.9-1.7,25.4c-0.4,8.3-0.3,16.6-1,24.9c-0.6,7-3.9,30.4-4.3,34.6 c-1.4,12.1-2.5,24.3-3.9,36.4c-1.5,13.6-2.5,27.3-4.2,40.9c-1.6,12.9-4.1,25.6-5.5,38.6c-0.5,4.8-23.9,193-24.9,202L47.4,772.6 L47.4,772.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000068652179259820675900000006798424427826376090_",
    gradientUnits: "userSpaceOnUse",
    x1: -103.0049,
    y1: 687.2849,
    x2: 357.7627,
    y2: 727.1591
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000036940519728302883520000011685680220887484314_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000068652179259820675900000006798424427826376090_)"
    },
    d: " M19.9,807.6c0.4-11.6,15.4-97.3,16.3-108.4c1.3-15.9,3.1-30.9,5-43.7c1.8-12.4,5.7-29.6,6.7-40.5c1.9-21.8,3.5-51.2,12.1-57 c6.1-4.1,14.1,0.2,26.4,3.2c7.6,1.8,16.4,5.5,26,5.3c27.2-0.6,51,1.1,54.3,11.5c2.2,6.8,1.5,14.9,0.4,27.4 c-1.1,12.2-0.4,29.6-2.4,54.3c-1.7,21.7-7.4,42.7-11,74.1c-4.2,36.2-6.6,88.5-9.8,120.5L19.9,807.6L19.9,807.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000036940519728302883520000011685680220887484314_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9900CC"
    },
    d: " M146.9,802.4l-19.1-2.7c-0.6-0.1-1-0.7-1-1.3c0.1-0.6,0.7-1,1.3-1l19,2.7L146.9,802.4L146.9,802.4z M97.5,818.7l-3-20.6 c-0.1-0.6,0.3-1.2,1-1.3c0.6-0.1,1.2,0.3,1.3,1l3.1,21.3L97.5,818.7L97.5,818.7z M151.9,749.3l-16.8-6.4c-0.6-0.2-0.9-0.9-0.7-1.5 c0.2-0.6,0.9-0.9,1.5-0.7l16.3,6.2l-0.1,1.4L151.9,749.3L151.9,749.3z M106.6,748l13.6,20.6c0.3,0.5,1,0.7,1.6,0.3 c0.5-0.3,0.7-1,0.3-1.6l-13.6-20.6c-0.3-0.5-1-0.7-1.6-0.3C106.4,746.8,106.3,747.5,106.6,748L106.6,748z M126.8,696.8l13.6,20.6 c0.3,0.5,1,0.7,1.6,0.3c0.5-0.3,0.7-1,0.3-1.6l-13.6-20.6c-0.3-0.5-1-0.7-1.6-0.3C126.6,695.6,126.5,696.3,126.8,696.8L126.8,696.8 z M66.8,791l-23.7,7c-0.6,0.2-0.9,0.8-0.8,1.4c0.2,0.6,0.8,0.9,1.4,0.8l23.7-7c0.6-0.2,0.9-0.8,0.8-1.4 C68,791.2,67.4,790.8,66.8,791L66.8,791z M87,765.2l-24.5,3c-0.6,0.1-1.1,0.6-1,1.3c0.1,0.6,0.6,1.1,1.3,1l24.5-3 c0.6-0.1,1.1-0.6,1-1.3C88.2,765.6,87.6,765.1,87,765.2L87,765.2z M162.8,675.2l-11.3,7.4c-0.5,0.3-1.2,0.2-1.6-0.3 c-0.3-0.5-0.2-1.2,0.3-1.6l13-8.5C163.1,673.2,163,674.2,162.8,675.2L162.8,675.2z M103.9,717l-20.5,13.8c-0.5,0.3-0.7,1.1-0.3,1.6 s1.1,0.7,1.6,0.3l20.5-13.8c0.5-0.3,0.7-1.1,0.3-1.6C105.1,716.8,104.4,716.6,103.9,717L103.9,717z M166.1,630l-8.8-4.2 c-0.6-0.3-0.8-0.9-0.5-1.5c0.3-0.6,0.9-0.8,1.5-0.5l7.9,3.8C166.2,628.3,166.2,629.1,166.1,630L166.1,630z M137.9,645.1l-13.2,20.8 c-0.3,0.5-0.2,1.2,0.3,1.6c0.5,0.3,1.2,0.2,1.6-0.3l13.2-20.8c0.3-0.5,0.2-1.2-0.3-1.6C138.9,644.4,138.2,644.5,137.9,645.1 L137.9,645.1z M102.1,686.1L78.5,679c-0.6-0.2-1.2,0.2-1.4,0.8c-0.2,0.6,0.2,1.2,0.8,1.4l23.7,7.1c0.6,0.2,1.2-0.2,1.4-0.8 C103.1,686.9,102.7,686.3,102.1,686.1L102.1,686.1z M28,752.4l12.1,3.9c0.6,0.2,0.9,0.8,0.7,1.4c-0.2,0.6-0.8,0.9-1.4,0.7 l-11.8-3.8l0.2-1.4L28,752.4L28,752.4z M56.5,735.9l2.6-24.6c0.1-0.6-0.4-1.2-1-1.2s-1.2,0.4-1.2,1l-2.6,24.6 c-0.1,0.6,0.4,1.2,1,1.2C55.8,737,56.4,736.6,56.5,735.9L56.5,735.9z M90.9,629.6l16.1,18.7c0.4,0.5,1.1,0.5,1.6,0.1 c0.5-0.4,0.5-1.1,0.1-1.6l-16.2-18.7c-0.4-0.5-1.1-0.5-1.6-0.1C90.5,628.5,90.5,629.2,90.9,629.6L90.9,629.6z M142.6,567.2 c1,0.1,2,0.2,2.9,0.4l11.1,16.8c0.3,0.5,0.2,1.2-0.3,1.6c-0.5,0.3-1.2,0.2-1.6-0.3L142.6,567.2L142.6,567.2z M132.6,602.6 l-24.5,3.3c-0.6,0.1-1.1,0.7-1,1.3c0.1,0.6,0.7,1.1,1.3,1l24.5-3.3c0.6-0.1,1.1-0.7,1-1.3C133.8,602.9,133.2,602.5,132.6,602.6 L132.6,602.6z M38.5,676.4l9.2,8.5c0.5,0.4,0.5,1.1,0.1,1.6c-0.4,0.5-1.1,0.5-1.6,0.1l-8-7.4C38.3,678.2,38.4,677.3,38.5,676.4 L38.5,676.4z M70.7,638.7L50.6,653c-0.5,0.4-0.6,1.1-0.3,1.6c0.4,0.5,1.1,0.6,1.6,0.3L72,640.5c0.5-0.4,0.6-1.1,0.3-1.6 C71.9,638.5,71.2,638.3,70.7,638.7L70.7,638.7z M109.2,566.3l-12.8,9.2c-0.5,0.4-1.2,0.2-1.6-0.3c-0.4-0.5-0.2-1.2,0.3-1.6 l10.7-7.7C106.9,566.2,108.1,566.3,109.2,566.3L109.2,566.3z M72.6,575.9l0.9,24.7c0,0.6,0.5,1.1,1.2,1.1c0.6,0,1.1-0.5,1.1-1.2 l-0.9-24.7c0-0.6-0.5-1.1-1.2-1.1C73.1,574.7,72.6,575.3,72.6,575.9L72.6,575.9z M48.7,605.2l12.4,1.1c0.6,0.1,1.1,0.6,1,1.2 c-0.1,0.6-0.6,1.1-1.2,1l-12.4-1.1l0.1-0.9c0-0.4,0.1-0.7,0.1-1.1L48.7,605.2L48.7,605.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000036940519728302883520000011685680220887484314_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FF7BAC"
    },
    d: " M76.8,504.6c-0.2-0.1-0.3-0.2-0.4-0.3c-1.3-1-2.3-2.5-2.8-3.7c-1.8-4.3-0.1-9.3,4.3-11.2c1.8-0.8,3.7-1,5.5-0.7 c1-1.4,2.3-2.5,3.8-3.2c2.9-1.3,6.5-1,9.2,0.6c0.7-0.5,1.6-1,2.4-1.3c2.4-1,5.2-1.1,7.5,0c0.9,0.4,1.7,0.9,2.4,1.5 c3.7-2.6,8.2-2.6,11.4,0.6c1.6-1.1,3.3-1.6,4.4-1.8c2.6-0.4,5.4,0.4,7.4,2.3c0.3-0.2,0.6-0.3,1-0.5c2.8-1.3,6.5-0.7,9.1,1.8 c1.7-0.8,3.7-1,6.1-0.4c1.6,0.4,3,1.2,4,2.2c2.7-1.6,6-1.7,8.5,1c2.1,2.3,2.2,5.3,0.7,8c-1.7,3.1-5.4,5.8-10,6.3l0.1-1.1 c0-0.4,0.1-0.8,0.1-1.1l0,0c3.6-0.6,6.4-2.7,7.8-5.1c1-1.8,1-3.8-0.4-5.4c-1.6-1.8-3.7-1.7-5.5-0.7c1,1.8,1.3,3.8,0.9,5.7 c-0.2,0.9-0.8,2-1.5,2.7c-1,0.9-2.2,1.2-3.5,0.5c-1.2-0.7-1.7-1.8-1.7-3.1c0-1.6,0.6-3.4,1.3-4.4c0.4-0.6,0.9-1.2,1.4-1.8 c-0.7-0.6-1.6-1.2-2.7-1.4c-1.5-0.4-2.9-0.3-4,0.1c0.2,0.4,0.4,0.7,0.6,1.1c1.1,2.3,1,4.7,0.2,6.4c-0.6,1.3-1.7,2.2-3,2.4 c-1.7,0.3-2.9-0.5-3.5-1.7c-0.8-1.5-0.8-3.9,0.1-5.7c0.6-1.1,1.3-2.1,2.1-2.9c-1.9-1.6-4.4-1.9-6.3-1.1c-0.1,0.1-0.3,0.1-0.4,0.2 c0.5,0.8,0.9,1.6,1.2,2.6c0.4,1.5,0.5,3.5-0.1,5.1c-0.4,1.3-1.2,2.3-2.4,2.7c-3.8,1.3-6.1-2.8-5.1-6.1c0.6-2,1.4-3.5,2.9-4.8 c-1.5-1.1-3.3-1.7-5.1-1.3c-0.8,0.1-2.1,0.5-3.4,1.4c0.5,0.8,0.8,1.7,1,2.6c0.6,2.1,0.6,4.9-1.1,6.7c-1.1,1.2-2.4,1.5-3.5,1.2 c-1.1-0.3-2-1.1-2.5-2.4c-0.5-1.5-0.4-3.5,0.9-5.8c0.6-1,1.2-1.8,1.9-2.5c-2.3-2.1-5.4-2.1-8.1-0.4c1.1,1.4,1.7,3,1.6,5 c-0.1,2.9-2.4,5.7-5.3,4.6c-1.5-0.5-2.2-1.8-2.3-3.3c-0.2-1.9,0.6-4.2,1.6-5.4c0.3-0.4,0.6-0.7,0.9-1.1c-0.5-0.3-1-0.7-1.6-0.9 c-1.7-0.8-3.8-0.7-5.7,0c-0.5,0.2-1,0.5-1.5,0.8c0.6,0.7,1.1,1.6,1.4,2.6c0.3,0.8,0.5,3,0.1,4.6c-0.4,1.4-1.3,2.5-2.8,2.7 c-1.7,0.3-2.8-0.6-3.4-2c-0.7-1.6-0.6-4.1,0-5.7c0.3-0.8,0.7-1.5,1.3-2.1c-1.9-1-4.5-1.1-6.6-0.2c-0.9,0.4-1.8,1.1-2.5,1.9 c0.9,0.5,1.7,1.1,2.5,1.9c1.1,1.2,2.2,3.6,2.1,5.7c-0.1,1.6-0.8,3-2.5,3.7c-1.7,0.7-3.1,0.2-4.2-0.9c-1.4-1.4-2.1-3.8-2.1-5.6 c0-1.2,0.3-2.3,0.8-3.4c-1.1-0.1-2.3,0.2-3.4,0.6c-3.3,1.4-4.4,5.1-3.1,8.3c0.2,0.6,0.6,1.2,1.1,1.8 C76.8,502.5,76.8,503.5,76.8,504.6L76.8,504.6z M151.5,493.6c-0.3,0.4-0.7,0.8-0.9,1.2c-0.5,0.7-1,2-0.9,3.1c0,0.5,0.1,1,0.6,1.2 c0.3,0.2,0.7,0,0.9-0.2c0.4-0.4,0.8-1,0.9-1.5C152.3,496.2,152.1,494.8,151.5,493.6L151.5,493.6z M141.5,491.7 c-0.7,0.6-1.2,1.4-1.6,2.2c-0.5,1-0.6,2.3-0.3,3.2c0.2,0.7,0.6,1.2,1.4,1c0.6-0.1,1-0.5,1.3-1.1c0.6-1.2,0.5-2.8-0.2-4.4 C141.9,492.2,141.7,491.9,141.5,491.7L141.5,491.7z M131.4,490.3c-1.2,1-1.9,2.2-2.3,3.7c-0.5,1.7,0.3,4.1,2.2,3.4 c0.5-0.2,0.8-0.7,1-1.3c0.4-1.2,0.4-2.7,0.1-3.8C132.1,491.6,131.8,490.9,131.4,490.3L131.4,490.3z M119.6,490.1 c-0.5,0.5-1,1.1-1.4,1.9c-1.1,1.9-1.1,3.6-0.5,4.5c0.2,0.3,0.5,0.5,0.8,0.5c0.4,0,0.7-0.2,1.1-0.6c1.1-1.2,0.9-3.1,0.5-4.6 C120,491.2,119.9,490.6,119.6,490.1L119.6,490.1z M108.4,489.3c-0.3,0.3-0.6,0.6-0.8,0.9c-0.7,0.9-1.3,2.5-1.1,3.8 c0.1,0.6,0.3,1.2,0.9,1.4c0.6,0.2,1.1,0,1.5-0.4c0.5-0.5,0.8-1.4,0.8-2.2C109.6,491.4,109.2,490.3,108.4,489.3L108.4,489.3z  M96.3,489.1c-0.4,0.5-0.7,1-0.9,1.6c-0.4,0.9-0.5,2.3-0.2,3.5c0.2,0.7,0.5,1.4,1.2,1.2c0.6-0.1,0.8-0.6,1-1.1 c0.3-1.2,0.1-2.7-0.1-3.4C97.1,490.2,96.8,489.6,96.3,489.1L96.3,489.1z M84.3,491.3c-0.4,0.9-0.7,1.9-0.7,2.9c0,1,0.3,2.4,1,3.4 c0.5,0.8,1.2,1.3,2.2,0.9c1-0.4,1.2-1.4,1.1-2.4c-0.1-1.3-0.8-2.6-1.5-3.3C85.8,492.1,85.1,491.6,84.3,491.3L84.3,491.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaceAndCultureFinal);
export default __webpack_public_path__ + "static/media/race_and_culture_final.ba3bda706bc5776fa510264d9e398df6.svg";
export { ForwardRef as ReactComponent };